import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class BaseService {
    constructor(protected toaster: ToastrService) {}

    handleError(error: any): Observable<any> {
        let errorMessage = '';
        this.handelErrors(error);
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error?.error?.ErrorMessage}`;
        }
        // this.loggerService.logError(errorMessage, error);
        return throwError(errorMessage);
    }

    handelErrors(error: { status: any; error: { errors: any } }): void {
        const status = error.status;
        if (status >= 400 && status < 500) {
            if (status === 422) {
                this.errors(error.error.errors);
            } else {
                this.handleExceptions(error);
            }
        } else if (status >= 500) {
            this.handleExceptions(error);
        }
    }
    handleExceptions(response: { status?: any; error: any; exception?: any; message?: any; statusText?: any }): void {
        if ('msg' in response.error) {
            this.toaster.error(response.error.msg);
        } else if ('exception' in response ? 'errorInfo' in response.exception : false) {
            const errorInfo = response.exception.errorInfo;
            if (typeof errorInfo == 'object') {
                this.toaster.error(errorInfo[errorInfo.length - 1]);
            }
        } else if ('message' in response) {
            this.toaster.error(response.message);
        } else if (response.statusText != '') {
            this.toaster.error(response.statusText);
        } else {
            this.toaster.error('Please contact Administrator');
        }
    }

    errors(errors: { [s: string]: unknown } | ArrayLike<unknown>): false {
        // let element = this;
        let limit = 0;
        if (errors) {
            let key = '';
            let value;
            for ([key, value] of Object.entries(errors)) {
                if (limit === 0) {
                    this.toaster.error(value?.toString());
                    // element.$refs[key].focus();
                    limit++;
                    return false;
                } else {
                    return false;
                }
            }
        }
        return false;
    }
}
